import $ from "jquery"
import "slick-carousel"

const heroOptions = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  prevArrow: '',
  nextArrow: ''
}


$('.jsHeroSlider').each(function () {
  console.log(this)
  $(this).slick(heroOptions);
});

const prodOptions = {
  dots: false,
  infinite: true,
  mobileFirst: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:
    '<div class="slick-arrow slick-arrow--prev"><svg ><use xlink:href="#chevron-double-left-regular"></use></svg></div>',
  nextArrow:
    '<div class="slick-arrow slick-arrow--next"><svg ><use xlink:href="#chevron-double-right-regular"></use></svg></div>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
      },
    },
  ],
}

$(".jsProdSlider").each(function (index) {
  $(this).slick(prodOptions)
})

const brendsOptions = {
  dots: false,
  infinite: true,
  mobileFirst: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  prevArrow: "",
  nextArrow: "",
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 6,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 8,
      },
    },
  ],
}

$(".jsBrendsSlider").each(function (index) {
  $(this).slick(brendsOptions)
})

const catMenuOptions = {
  dots: false,
  infinite: true,
  mobileFirst: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  prevArrow:
    '<div class="slick-arrow slick-arrow--prev"><svg ><use xlink:href="#chevron-double-left-regular"></use></svg></div>',
  nextArrow:
    '<div class="slick-arrow slick-arrow--next"><svg ><use xlink:href="#chevron-double-right-regular"></use></svg></div>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6,
      },
    },
  ],
}

$("#catMenu").slick(catMenuOptions)

function prodSlider() {
  $("#mainImage").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow:
      '<div class="slick-arrow slick-arrow--prev"><svg ><use xlink:href="#chevron-double-left-regular"></use></svg></div>',
    nextArrow:
      '<div class="slick-arrow slick-arrow--next"><svg ><use xlink:href="#chevron-double-right-regular"></use></svg></div>',
    asNavFor: "#imageNav",
  })
  $("#imageNav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: "#mainImage",
    mobileFirst: true,
    arrows: false,
    dots: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 8,
        },
      },
    ],
  })
}
prodSlider()
window.addEventListener("reset", prodSlider)

$("#mainBlogImg").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  prevArrow: "",
  nextArrow: "",
  asNavFor: "#blogImgNav",
})
$("#blogImgNav").slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  asNavFor: "#mainBlogImg",
  mobileFirst: true,
  arrows: true,
  prevArrow:
    '<div class="slick-arrow slick-arrow--prev"><svg ><use xlink:href="#chevron-double-left-regular"></use></svg></div>',
  nextArrow:
    '<div class="slick-arrow slick-arrow--next"><svg ><use xlink:href="#chevron-double-right-regular"></use></svg></div>',
  dots: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        vertical: true,
        verticalSwiping: true,
      },
    },
  ],
})
